/**
 * Abre a impressão do navegador ("Salvar como PDF") com o relatório pronto para o papel.
 *
 * 1. Tema claro (legibilidade e tinta); os gráficos observam `data-theme` e se repintam.
 * 2. `modo-impressao` estreita o `.report-printable` para a largura útil da A4 (ver
 *    `styles/print.css`): os gráficos se redesenham nessa largura e não saem cortados.
 * 3. Espera o redesenho, imprime e desfaz tudo no `afterprint`.
 */
export const ESPERA_REDESENHO_MS = 400;

export function imprimirRelatorio(): void {
  const html = document.documentElement;
  const tema = html.getAttribute('data-theme');
  html.setAttribute('data-theme', 'light');
  html.classList.add('modo-impressao');

  const restaurar = () => {
    if (tema === null) html.removeAttribute('data-theme');
    else html.setAttribute('data-theme', tema);
    html.classList.remove('modo-impressao');
  };
  window.addEventListener('afterprint', restaurar, { once: true });
  window.setTimeout(() => window.print(), ESPERA_REDESENHO_MS);
}
